import { httpClient } from './http-client';

export const getPageInformation = async (id) => {
  try {
    const response = await httpClient.get('api/page-details.php', {
      params: {
        pageId: id,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching files:', error);
    throw error;
  }
};

export const getPageFiles = async (id) => {
  try {
    const response = await httpClient.get('api/page_files_list.php', {
      params: {
        pageId: id,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching files:', error);
    throw error;
  }
};
